export interface Message {
  color: string,
  contactId: string,
  createdAt: number,
  message: string,
  messageId: string,
  name: string,
  owner: boolean,
  photo: string,
  reply: boolean,
  userId?: number
}

export interface MessageOrigin {
  contactId: string,
  message: string,
  messageId: string,
  name: string,
  owner: boolean,
  userId?: number
}

export interface Messages {
  message: MessageWithReply[]
}

export interface MessageWithReply extends Message {
  messageOrigin?: MessageOrigin
}

export interface MessageReceivedContact {
  id: string,
  name: string,
  userId: string,
  picture?: string
}

export interface MessageReceivedPayload {
  channel: string,
  contact?: MessageReceivedContact,
  contactId: string,
  content: {
    text: string,
    type: string
  },
  conversationId: string,
  conversationTenant?: string,
  deletedAt?: number,
  id: string,
  metadata: {
    externalId: string,
    parentContent?: {
      contact: MessageReceivedContact,
      subject?: string,
      text: string,
      type: string
    }
  },
  parentId?: string,
  sentAt: number,
  threadId: string,
  type: string,
  updatedAt: string
}

export interface MessageDeletedPayload {
  id: string
}

export interface InitializeSparkiePayload {
  token: string,
  webinarConversationId?: string,
  skipPresenceSetup?: boolean
}

export interface GetMessagesPayload {
  conversationId: string,
  before?: number | undefined
}

export interface SendMessagePayload {
  conversationId: string,
  message: string,
  reply?: MessageWithReply
}
export interface GetConversationResponse {
  id: string,
  type: string,
  tenant: string,
  metadata: {
    owner: string
  }
}

export interface GetProfileResponse {
  id: string,
  name: string,
  picture: string,
  userId: string
}

export enum ActionsName {
  MESSAGE_RECEIVED = 'messageReceived',
  MESSAGE_DELETED = 'messageDeleted',
  VISIBILITY_CHANGED = 'visibilityChanged',
  ONLINE_COUNTER_UPDATE = 'onlineCounterUpdate',
  PARTICIPANTS_UPDATE = 'participantUpdate'
}

export interface ParticipantsUpdatePayload {
  contactId: string,
  conversationId: string,
  joinedAt: string,
  permissions: {
    addParticipants: boolean,
    editConversation: boolean,
    editParticipants: boolean,
    moderateMessages: boolean,
    readMessages: boolean,
    writeMessages: boolean
  },
  updatedAt: string
}

export type ParticipantsUpdateCallback = (value: ParticipantsUpdatePayload) => void

export interface Actions {
  [ActionsName.MESSAGE_RECEIVED]?: (payload: MessageReceivedPayload) => void,
  [ActionsName.MESSAGE_DELETED]?: (event: MessageDeletedPayload) => void,
  [ActionsName.VISIBILITY_CHANGED]?: (visibility: boolean) => void,
  [ActionsName.ONLINE_COUNTER_UPDATE]?: (counter: number) => void,
  [ActionsName.PARTICIPANTS_UPDATE]?: ParticipantsUpdateCallback
}

export interface AnonymousPayload {
  email?: string,
  name?: string
}

export interface C3POProfile {
  id: string,
  name: string,
  picture: string,
  userId: string
}

export interface SparkieAdminListItem {
  stringValue?: string
}
